import React, { useState } from "react";

function Ce(props) {
  const [ce, setCe] = useState();
  const error = "Votre score doit être entre 342 et 699";
  const [nclcCE, setNclcCe] = useState("");
  function handler(e) {
    setCe(e.target.value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (nclcCE !== error) {
      props.onSubmit(nclcCE);
    }
  };
  return (
    <div>
      <form className="Input" onSubmit={handleSubmit}>
        <span>compréhension écrite :</span>
        <div className="row">
          <input
            className="Score"
            type={"number"}
            placeholder={"Saisissez votre score en CE.."}
            onChange={handler}
          />
          <button
            type="submit"
            className="ButtonNCLC"
            onClick={() => {
              if (ce >= 342 && ce <= 374) {
                setNclcCe(4);
              } else if (ce >= 375 && ce <= 405) {
                setNclcCe(5);
              } else if (ce >= 406 && ce <= 452) {
                setNclcCe(6);
              } else if (ce >= 453 && ce <= 498) {
                setNclcCe(7);
              } else if (ce >= 499 && ce <= 523) {
                setNclcCe(8);
              } else if (ce >= 524 && ce <= 548) {
                setNclcCe(9);
              } else if (ce >= 549 && ce <= 699) {
                setNclcCe(10);
              } else {
                setNclcCe(error);
              }
            }}
          >
            NCLC
          </button>
          <h3 className="result">{nclcCE}</h3>
        </div>
      </form>
    </div>
  );
}

export default Ce;
